interface IUserUnauthenticated {
  isAuthenticated: false;
}

interface IUserPhone {
  phone: string;
  confirmed: boolean;
}

interface IUserPermissions {
  canViewUsers: boolean;
  canViewListingSort: boolean;
  canViewAnnouncements: boolean;
  canUseHiddenBase: boolean;
  canModerateUsers: boolean;
  canModerateAnnouncements: boolean;
  canModerateAnnouncementsExpert: boolean;
}

interface IUserAuthenticated {
  accountType: 'natural' | 'legal';
  agentAccountType: 'specialist' | 'agency';
  balance: number;
  displayName: string | null;
  email: string;
  firstName: string | null;
  /**
   * CianId
   */
  id: number;
  isAgent: boolean;
  isBuilder: boolean;
  isAuthenticated: true;
  isModerator: boolean;
  isNew: boolean;
  isProfi: boolean;
  isSubscriptions: boolean;
  lastName: string | null;
  permissions: IUserPermissions;
  phones: IUserPhone[] | null;
  publicProfile: boolean;
  tariff: string[];
  /**
   * RealtyId
   */
  userId: number;
  userType: string;
  webimHash: string | null;
  lkType: EUserType;
}

export type TUser = IUserUnauthenticated | IUserAuthenticated;

export interface ITrackingUserAuthorized {
  userId: number | null;
  extra: {
    defaultRegionId: number;
  };
}

export type TTrackingUser = ITrackingUserAuthorized | {};

export enum EUserType {
  /** Неопределенный **/
  'Undefined' = 'undefined',
  /** Собственник **/
  'Homeowner' = 'homeowner',
  /** Специалист **/
  'Specialist' = 'specialist',
}
